
import './App.css';
import { AuthProvider } from './Base/Context/AuthContext/AuthContext';
import { ConfigProvider } from './Base/Context/ConfigContext/ConfigContext.js';
import { AppRouter } from './Base/Router/AppRouter';

import 'remixicon/fonts/remixicon.css'

function App() {

  return (
    <AuthContainter>
      <ConfigContainter>
        <div style={{ overflow: 'hidden', }} className={'animate__animated animate__fadeIn tableAnimate '}>
          <AppRouter />
        </div>
      </ConfigContainter>
    </AuthContainter>
  );
}


const AuthContainter = ({ children }) => {
  return <AuthProvider>{children}</AuthProvider>
}

const ConfigContainter = ({ children }) => {
  return <ConfigProvider>{children}</ConfigProvider>
}


export default App;
